import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "stores/Interfaces";
import { Input, Form } from "antd";
import { FieldConfig, Option } from "components/common/forms/Interfaces";

interface Props {
  value: string;
  store?: IAppStore;
  name: string;
  config?: FieldConfig;
  options?: Option[];
  type?: string;
  height?: string;
  disabled?: boolean;
}

const TextInput: React.FC<Props> = ({
  store,
  value,
  name,
  config,
  type = "text",
  height = "40px",
  disabled = false,
  ...rest
}) => {
  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0 }}
      normalize={(e) => (type === "number" ? parseFloat(e) : e)}
      {...(config?.extra || {})}
      {...rest}
    >
      <Input
        style={{ height }}
        defaultValue={value}
        key={name}
        type={type}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default inject("store")(observer(TextInput));
